import React from "react";
// Components
import darkLogoImg from "~/assets/img/defaultImg/dark-logo-square.png";
import lightLogoImg from "~/assets/img/defaultImg/light-logo-square.png";
import FusionCharts from "fusioncharts";
import charts from "fusioncharts/fusioncharts.charts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import ReactFusionCharts from "react-fusioncharts";
import bubbleChartBg from "~/assets/img/bg-bubble-line.png";
import { INVEST_STEP } from "~/constant/ApplyFormConstant";
import { thousandFormatter } from "~/utils/formatter";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "~/store";
import { PortfolioEmptyIcon } from "~/assets/svg/InterfaceIcon";
import { useNavigate } from "react-router";

FusionCharts.options.creditLabel = false;
ReactFusionCharts.fcRoot(FusionCharts, charts, FusionTheme);

const ListItem = ({ item, keywords, onClickItem, hisArr, category, dataSet, idx }) => {
	const navigate = useNavigate();
	const { t } = useTranslation();

	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();

	// bubble chart
	const config = {
		type: "bubble",
		dataFormat: "json",
		width: "100%",
		height: "266",
		containerBackgroundOpacity: "0",
		dataSource: {
			chart: {
				xAxisMinValue: "0",
				yAxisMinValue: "0",
				xAxisMaxValue: "1700",
				yAxisMaxValue: "135",
				xAxisValuesStep: "1",
				showYAxisValues: "0",
				showXAxisLine: "0",
				bgImage: bubbleChartBg,
				bgAlpha: "0",
				bgImageDisplayMode: "center",
				divLineAlpha: "0",
				plotFillAlpha: "80",
				plotFillHoverColor: "#603aff",
				showTooltip: false,
				theme: "fusion",
				bubbleScale: 3,
				showValues: "1",
			},
			categories: [
				{
					category: category,
				},
			],
		},
	};

	const dataset = {
		dataset: [
			{
				color: "#c9ced6",
				plotFillAlpha: 80,
				data: dataSet,
			},
		],
	};

	const withdrawValue = item.withdrawValue;
	const vcInvestValue = item.vcInvestValue;

	const recoveryRate = () => {
		if (withdrawValue === 0 || vcInvestValue === 0) return <></>;
		if (vcInvestValue > withdrawValue)
			return (
				<li className="company-value percent minus">
					▼ {thousandFormatter(((withdrawValue / vcInvestValue) * 100).toFixed(2)) || 0}%
				</li>
			);
		return (
			<li className="company-value percent plus">
				▲ {thousandFormatter(((withdrawValue / vcInvestValue) * 100).toFixed(0)) || 0}%
			</li>
		);
	};

	const recoveryMark = () => {
		if ((withdrawValue / vcInvestValue) * 100 >= 100) {
			return <div className="recover-mark">회수</div>;
		} else {
			return <></>;
		}
	};

	return (
		<li className="portfolio-item">
			<div className="item-left" onClick={() => onClickItem && onClickItem()}>
				<div className="mark-wrap">
					{recoveryMark()}
					<div className="img-wrap">
						<img
							src={
								item.logoSqu
									? item.logoSqu
									: theme === "dark"
									? darkLogoImg
									: lightLogoImg
							}
							alt={t("pages.portfolio.PortfolioList.components.ListItem.logo")}
						/>
					</div>
				</div>
				<div className="company-data">
					<div className="company-wrap">
						<h4 className="company-invest">{INVEST_STEP[item.step - 1]}</h4>
						<ul className="company-info">
							<li className="info-item name">{item.name}</li>
							{item.industryCondition && (
								<li className="info-item">{item.industryCondition}</li>
							)}
							<li className="info-item">
								{item.area} {item.esYear}
								{t("pages.portfolio.PortfolioList.components.ListItem.year")}
							</li>
						</ul>
						<p className="company-desc">{item.description}</p>
					</div>
					<div className="company-field c__tag-wrap">
						{keywords &&
							keywords.map((keyword, index) => {
								return (
									<span key={index} className="c__tag-view">
										{keyword}
									</span>
								);
							})}
					</div>
					<ul className="company-value-wrap">
						<li className="company-value">
							{t("pages.portfolio.PortfolioList.components.ListItem.companyValue")} :{" "}
							{thousandFormatter(item.investComValue) || 0}
							{t("pages.portfolio.PortfolioList.components.ListItem.hMillion")}
						</li>
						<li className="company-value">
							{t("pages.portfolio.PortfolioList.components.ListItem.invest")} :{" "}
							{thousandFormatter(item.vcInvestValue) || 0}
							{t("pages.portfolio.PortfolioList.components.ListItem.hMillion")}
						</li>
						<li className="company-value">
							{t("pages.portfolio.PortfolioList.components.ListItem.recover")} :{" "}
							{thousandFormatter(item.withdrawValue) || 0}
							{t("pages.portfolio.PortfolioList.components.ListItem.hMillion")}
						</li>
						{recoveryRate()}
					</ul>
				</div>
			</div>
			<div className="item-right">
				<div className="invest-content">
					{hisArr?.length > 0 ? (
						<ReactFusionCharts
							{...{
								...config,
								dataSource: {
									...config.dataSource,
									...dataset,
								},
							}}
						/>
					) : (
						<div className="no-data">
							<PortfolioEmptyIcon />
							<div>
								<p className="main-desc">투자 이력정보가 없습니다.</p>
								<p className="sub-desc">지금 바로 투자상세 정보를 입력해 주세요.</p>
							</div>
							<button
								type="button"
								color="black"
								className="btn__solid btn-enter"
								onClick={() => navigate(`/portfolio/view/${idx}`)}
							>
								입력하기
							</button>
						</div>
					)}
				</div>
			</div>
		</li>
	);
};

export default ListItem;
